/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { Injector, StaticProvider } from "@angular/core";

import { platformWorkerInjector } from "./worker_injector";

export { WORKER_FETCH_RESPONSE, WORKER_REF } from "./worker_injector";

export {
  ClientMessageBroker,
  ClientMessageBrokerFactory,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "./web_workers/shared/client_message_broker";
export { MessageBus, MessageBusSink, MessageBusSource } from "./web_workers/shared/message_bus";
export { PRIMITIVE, Serializer } from "./web_workers/shared/serializer";
export {
  ReceivedMessage,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "./web_workers/shared/service_message_broker";
export { WORKER_APP_LOCATION_PROVIDERS } from "./web_workers/worker/location_providers";
export { WorkerAppModule, platformWorkerApp } from "./worker_app";

/**
 * Bootstraps the worker ui.
 *
 * TODO Add funcationality for Array of workers as
 *      registry implementing port based brokers is done
 *
 * @experimental
 */
export async function bootstrapWorkerProvider(
  workerScriptUri: Array<string>,
  customProviders: StaticProvider[] = [],
): Promise<Injector> {
  // For now, just creates the worker ui platform...
  return await platformWorkerInjector(workerScriptUri, customProviders);
}
